import { createSelector } from 'reselect';
import { getPageData } from 'src/universal/redux/page.js';

export const getDynAppBannerData = createSelector(
  [getPageData],
  ({ dynamicAppBanner }) => {
    return dynamicAppBanner;
  }
);
